import { render, staticRenderFns } from "./AppInfoModal.vue?vue&type=template&id=55a92870&scoped=true&"
import script from "./AppInfoModal.vue?vue&type=script&lang=js&"
export * from "./AppInfoModal.vue?vue&type=script&lang=js&"
import style0 from "./AppInfoModal.vue?vue&type=style&index=0&id=55a92870&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a92870",
  null
  
)

export default component.exports